import React, { isValidElement } from "react";
import Link from "@/components/Link";
import NextImage, { ImageProps } from "next/image";

import ConditionalWrap from "@/components/ConditionalWrap";

type Props = {
  src: string;
  link?: string;
  alt?: string;
} & ImageProps;

interface WrapProps {
  children: React.ReactNode;
}

const Image: React.FC<Props> = ({ src, link = null, alt = "", ...props }) => {
  if (isValidElement(src)) {
    return src;
  }

  return (
    <ConditionalWrap
      condition={!!link}
      wrap={({ children }: WrapProps) => (
        <Link href={link as string}>{children}</Link>
      )}
    >
      <NextImage src={src} alt={alt} {...props} />
    </ConditionalWrap>
  );
};

export default Image;
